/**
 * Drawer configuration constants
 */

// Animation duration for drawer transitions (ms)
export const DRAWER_ANIMATION_DURATION = 200;

// Landscape drawer width (px)
export const DRAWER_WIDTH = 375;

// Landscape drawer right margin (px)
export const DRAWER_RIGHT_MARGIN = 12;

// Portrait drawer height ratio (3/4 of screen)
export const DRAWER_HEIGHT_RATIO = 0.75;
